import { Checkbox, TableCell, TableRow, Typography, tableCellClasses } from "@mui/material";
import { format } from "date-fns";
import { Fragment } from "react";
import { Control, Controller } from "react-hook-form";

import { GqlAvailability, GqlAvailabilityPeriod } from "~/__generated__";

import { FieldworkerAvailabilityFormData } from ".";

type Props = {
    name: string;
    period: GqlAvailabilityPeriod;
    availabilities: GqlAvailability[];
    control: Control<FieldworkerAvailabilityFormData>;
    userAvailabilityDays: { [slotId: string]: boolean[] };
};

export default function FieldworkerAvailabilitySlots({
    name,
    period,
    availabilities,
    control,
    userAvailabilityDays,
}: Props) {
    return (
        <Fragment>
            <TableRow>
                <TableCell colSpan={8}>
                    <Typography variant="h6">{name}</Typography>
                    <Typography variant="caption">
                        <strong>{format(period.startAt, "dd MMM")}</strong> -{" "}
                        <strong>{format(period.endAt, "dd MMM")}</strong>
                    </Typography>
                </TableCell>
            </TableRow>
            {availabilities.map(availability => (
                <Fragment key={availability.id}>
                    <TableRow
                        sx={{
                            [`& .${tableCellClasses.root}`]: {
                                borderBottom: "none",
                            },
                        }}
                    >
                        <TableCell variant="head">
                            <Typography>{availability.name}</Typography>
                            <Typography variant="caption">{availability.time}</Typography>
                        </TableCell>
                        {Array.from({ length: 7 }, (_, i) => (
                            <TableCell key={i}>
                                <Controller
                                    name={`days.${availability.id}.${i}`}
                                    control={control}
                                    render={({ field }) => {
                                        const userAvailabilityCount = userAvailabilityDays[availability.id].filter(
                                            value => value === true,
                                        ).length;

                                        const isMinimumAvailability =
                                            availability.minimumAvailability === userAvailabilityCount;

                                        return (
                                            <Checkbox
                                                checked={field.value}
                                                onChange={field.onChange}
                                                disabled={isMinimumAvailability && field.value}
                                            />
                                        );
                                    }}
                                />
                            </TableCell>
                        ))}
                    </TableRow>
                    {availability.description && (
                        <TableRow>
                            <TableCell colSpan={8}>
                                <Typography variant="caption">{availability.description}</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </Fragment>
            ))}
        </Fragment>
    );
}
